export class TurnstileWidgetLifecycle {
  constructor({ container, script, siteKey, theme = "light", apiProvider }) {
    this.container = container;
    this.script = script;
    this.siteKey = siteKey;
    this.theme = theme;
    this.apiProvider = apiProvider;
    this.widgetId = null;
    this.renderWhenReady = () => this.render();
  }

  connect() {
    if (this.apiAvailable()) {
      this.render();
    } else {
      this.script?.addEventListener("load", this.renderWhenReady);
    }
  }

  disconnect() {
    this.script?.removeEventListener("load", this.renderWhenReady);
    const api = this.apiProvider();
    if (this.widgetId !== null && api?.remove) {
      api.remove(this.widgetId);
    }
    this.widgetId = null;
  }

  render() {
    if (this.widgetId !== null) return;

    const api = this.apiProvider();
    if (!api?.render) return;

    this.container.replaceChildren();
    this.widgetId = api.render(this.container, {
      sitekey: this.siteKey,
      theme: this.theme,
      retry: "auto",
      "expired-callback": () => this.reset(),
      "timeout-callback": () => this.reset(),
      // Cloudflare owns error retries. Returning false preserves its diagnostics
      // and avoids racing an immediate manual reset against the auto-retry.
      "error-callback": () => false,
    });
  }

  reset() {
    const api = this.apiProvider();
    if (this.widgetId !== null && api?.reset) api.reset(this.widgetId);
  }

  apiAvailable() {
    return typeof this.apiProvider()?.render === "function";
  }
}
